import axios from 'axios'
import { useCallback, useEffect, useState, useRef, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import { useParams } from 'react-router-dom'
import { SwiperSlide, Swiper } from 'swiper/react'
import PopupWithHeading from '../../components/popupWithHeading'
import SMSCheck from "../cart/components/smsCheck";
import './index.css'
import config from '../../configuration/config.json'
import moment from "moment";
import Navbar from '../../components/navbar'
import { Price } from '../../components/__simple/_price'
import { useContext } from 'react'
import ThemeContext from '../../utils/contexts/themeContext'
import { sum } from 'lodash'
import { toast } from "react-toastify";
import Table from 'react-bootstrap/Table';
import Popup from '../../components/popup'
import CenterInfo from "../fixAgreement/center_Info";
import SimpleButton from "../../components/_input/SimpleButton";
const Addationals = ({ salesOrder, orderCustInfo, orderTrans, orderAuthorized }) => {
  const { t: trans, i18n } = useTranslation(['mobileCommon', 'new', 'fixAgreemnet'])
  let lang = i18n.language
  const [termsSalesOrders, setTermsSalesOrders] = useState([]);
  const [indexPanel, setIndexPanel] = useState('4000')
  const [showPanel, setShowPanel] = useState(true)
  const [showPopup, setShowPopup] = useState(false);
  const [showTermsPopup, setShowTermsPopup] = useState(false)
  const { number } = useParams();
  const [isLoadingStatus, setIsLoadingStatus] = useState(true);
  const [vehicleAtts, setVehicleAtts] = useState([]);
  const [fixAgreement, setFixAgreement] = useState({});
  const themeMode = useContext(ThemeContext);
  const [addationals, setAddationals] = useState([]);
  const [hasaddationals, setHasAddationals] = useState(true);
  const [addationalPrice, setAddationalPrice] = useState(0);
  const [noneItems, setNoneItems] = useState(null);
  const [outerItems, setOuterItems] = useState({});
  const checkAllRef = useRef();
  const popRef = useRef(null)
  const [isLoading, setIsLoading] = useState(false);
  const [showFinalPopup, setShowFinalPopup] = useState(false);

  const [cinderInfo, setCinderInfo] = useState({});


  const [postedDate, setPostedDate] = useState('');


  const initCallback = useCallback(async () => {
    try {
      console.log("initCallback :");
      setShowFinalPopup(false);
      if (number) {
        axios.post(`${config.controllerUrl}${lang}/api/Maintenance/fixAgreement/${number}`)
          .then(response => {
            console.log("fixAgreement :", response);
            console.log("fixAgreement.response.status :", response.status);
            if (response.status === 200) {
              setIsLoadingStatus(false);
              GetEstimationConfirmDate(number);

              if (response?.data?.intro?.orderNo != null && response?.data?.intro?.orderNo != '') {
                GetCenterInfo(response?.data?.intro?.orderNo);

                let dataTerms;
                if (response?.data?.intro?.termsConditions != null && response?.data?.intro?.termsConditions != '') {
                  let termBefore = response?.data?.intro?.termsConditions;
                  let termAfter = termBefore.toString().replaceAll("\\n", "\n").split('\n');
                  dataTerms = termAfter;
                  setTermsSalesOrders(dataTerms);
                }

              }


              if (!response?.data?.intro)
                setShowFinalPopup(true);


              var currentOuterItems = {};

              try {

                response?.data?.outerItems?.map((item, index) => {

                  currentOuterItems[item.itemCode] = item.selected;

                });
                setOuterItems(currentOuterItems);

              } catch (error) {

              }


              setFixAgreement(response?.data);

              if (response?.data?.intro?.isClosed || response?.data?.intro?.orderStatus != "Open wait Approval")
                  // setShowFinalPopup(true);


              if (response?.data?.intro?.esitimations?.length == 0)
                setHasAddationals(false);

              setAddationalItem(response?.data?.intro?.esitimations);
            } else {

              setShowFinalPopup(true);
            }
          }).catch(error => {
            console.log(error);
          setIsLoadingStatus(false);
            setShowFinalPopup(true);
          throw error;
          });
      }
    } catch (e) {
      console.log(e);
      setShowFinalPopup(true);
    }
  }, [lang]);


  const vehicleAttatchment = useCallback(async () => {
    try {


      if (number) {
        axios.post(`${config.controllerUrl}${lang}/api/Maintenance/fixAgreementImages/${number}`)
          .then(response => {
            if (response.status === 200) {
              setVehicleAtts(response.data);
            }
          }).catch(error => {
            console.log(error);
          });
      }
    } catch (e) {
      console.log(e);
    }
  }, []);


  // * GetCenterInfo
  async function GetCenterInfo(dateRec) {
    console.log("Get CenterInfo Reception Number Start: ", dateRec);

    try {
      await axios.request({
        url: config.controllerUrl + 'api/Addationals/GetCenterInfo',
        data: { guid: dateRec }, method: "POST", responseType: "json"
      })
          .then(async function (response) {
            //setIsLoading(false);
            console.log("GetCenterInfoJobCardAddtional Reception status: ", response.status);

            if (response.status >= 200 && response.status <= 300) {
              console.log("GetCenterInfoJobCardAddtional Reception data: ", response.data);
              if (response.data != null) {
                setCinderInfo(response?.data[0]);
              }
            }
          })
          .catch(function (error) {
            toast.error(trans("error:error_get_info") + ' ' + trans("error:info_center") + ' ' + error.toString());
            console.log("GetCenterInfoJobCardAddtional: ", error);
          });

    } catch (ex) {
      toast.error(trans("error:error_get_info") + trans("error:info_center") + ' ' + ex.toString());
      console.log("Catch Error GetCenterInfoJobCardAddtional: ", ex)
    }
  }


  const showPanelInfo = (currentIndexPanel) => {
    if (currentIndexPanel != indexPanel) {
      setIndexPanel(currentIndexPanel)
      setShowPanel(true)
    } else {
      setIndexPanel(currentIndexPanel)
      setShowPanel(!showPanel)
    }
  }



  const checkAllAddational = () => {
    if (checkAllRef.current.checked) {
      const newResult = addationals?.map(item => {
        return { ...item, approval: true }
      })
      setAddationals(newResult);
      setNoneItems(true);
      setAddationalPrice(sum(newResult?.map(item => item?.priceAfterDisc)));
    } else {
      setAddationals(addationals?.map(item => {
        return { ...item, approval: false }
      }));
      setAddationalPrice(0);
      setNoneItems(false);
    }
  }

  const checkAddationalItem = (event, item) => {
    if (fixAgreement?.intro?.isClosed) {
      event.preventDefault();
      return;
    }
    const newResult = addationals?.map(itemVal => {
      if (itemVal?.itemCode === item?.itemCode) {
        return { ...itemVal, approval: event.target.checked }
      }
      return itemVal;
    });


    setAddationalItem(newResult);
  }


  const setAddationalItem = (newResult) => {

    setAddationals(newResult);
    const itemApproval = newResult?.filter(itemValue => itemValue?.approval);
    setAddationalPrice(sum(itemApproval?.map(itemVal => itemVal?.priceAfterDisc)))

    if (checkAllRef.current?.checked && itemApproval?.length === 0) {
      setNoneItems(false);
      return;
    } else if (itemApproval?.length === newResult?.length) {
      setNoneItems(true);
      return;
    }
    setNoneItems(false);
  }

  // const callTerms = useCallback(() => {
  //   const Body = {
  //     name: 'fetch_termsSO'
  //   };
  //
  //   if (!termsSalesOrders) {
  //     axios
  //       .request({
  //         url: config.baseURLSadad + 'func',
  //         data: Body,
  //         method: 'POST',
  //         responseType: 'json',
  //       })
  //       .then(function (response) {
  //         let finalResponse = {
  //           title: null,
  //           image: null,
  //         };
  //         if (lang === 'ar') {
  //           finalResponse.image = response.data[0].imageAr;
  //           finalResponse.title = response.data[0].descriptionAR;
  //         } else {
  //           finalResponse.image = response.data[0].imageEn;
  //           finalResponse.title = response.data[0].descriptionEn;
  //         }
  //
  //         setTermsSalesOrders(finalResponse);
  //       })
  //       .catch(function (error) {
  //         console.log(error)
  //       })
  //   }
  //   setShowTermsPopup(true);
  // }, []);

  // * GetEstimationConfirmDate
  async function GetEstimationConfirmDate(dateRec) {
    console.log("GetEstimationConfirmDate Start: ", dateRec);

    try {
      await axios.request({
        url: config.controllerUrl + 'api/Addationals/GetEstimationConfirmDate',
        data: { guid: dateRec }, method: "POST", responseType: "json"
      })
          .then(async function (response) {
            console.log("GetEstimationConfirmDate status: ", response.status);

            if (response.status >= 200 && response.status <= 300) {
              console.log("GetEstimationConfirmDate data: ", response.data);
              if (response.data != null && response?.data[0] != null && response?.data[0]['PostedDate'] != null) {
                setPostedDate(response?.data[0]['PostedDate']);
              }
            }
          })
          .catch(function (error) {
            console.log("GetEstimationConfirmDate: ", error);
          });

    } catch (ex) {
      console.log("Catch Error GetEstimationConfirmDate: ", ex)
    }
  }

  useEffect(() => {
    initCallback();
    vehicleAttatchment();
  }, []);

  const [isLoadingBtn, setIsLoadingBtn] = useState(false);

  const nextStepCallback = useCallback(async () => {
    setIsLoadingBtn(true)
    try {
      setShowPopup(false);
      console.log("nextStepCallback :", addationals);
      if (number) {
        axios.request({
          url: `${config.controllerUrl}${lang}/api/Maintenance/updateAddationals/${number}`,
          data: addationals, method: "POST", responseType: "json"
        }).then(response => {
          console.log("response :", response);
          if (response.status === 200) {
            if (response?.data)
              setShowFinalPopup(true);
          }
        }).catch(error => {

        });
      }
      setIsLoadingBtn(false);
    } catch (e) {
      setIsLoadingBtn(false)
      console.log(e);

    }
  }, [addationals]);

  const handelGoCheckSms = async () => {

    // nextStepCallback();
    if (!isLoading) {



      if (!(fixAgreement?.host?.ownerMobile && fixAgreement?.host?.ownerMobile != "0")) {

        toast.success(trans("new:mobile_not_found"));
        return
      }

      if (!(addationalPrice && addationalPrice != "0")) {

        toast.success(trans("new:The_amount_cannot_be_zero"));
        return
      }

      setShowPopup(true);

    }


  }






  return (
    isLoadingStatus ? (
      <>
        <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"10rem"}
          containerClassName={"my-5"} className={"flex my-5"} inline={false} />

        <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"50rem"}
          containerClassName={"my-5"} className={"flex my-5"} inline={false} />

        <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"50rem"}
          containerClassName={"my-5"} className={"flex my-5"} inline={false} />

        <Skeleton count={10} borderRadius={"1rem"} width={"70%"} height={"5rem"}
          containerClassName={"my-5"} className={"flex my-5"} inline={false} />

        <Skeleton count={2} borderRadius={"1rem"} width={"50%"} height={"10rem"}
          containerClassName={"flex flex-row nice-gap-2rem my-20"} className={"flex flex-row nice-gap-2rem my-20"} inline={true} />
      </>

    ) : (
      <div className={` unselectable theme-${themeMode}`}>
        {/* start navbar */}
        <Navbar title={trans('fixAgreemnet:fix_agreement')} />
        {/* end navbar */}

        <>

          {/* start agreement */}
          <div className="nice-container flex flex-col nice-gap-1rem mb-10 mt-20 pt-10">
            <div className="flex flex-row nice-gap-1rem">
              <span className="text-30 text-bold text-nowrap text-capitalize">
                {trans('fixAgreemnet:agreement_number')}:
              </span>
              <span className="text-30 text-bold">{fixAgreement?.intro?.orderNo}</span>
            </div>

            <div className="flex flex-row nice-gap-1rem">
              <span className="text-30 text-nowrap text-capitalize">
                {trans('fixAgreemnet:date_time')}:
              </span>
              <span className="text-30 language-en">
                {fixAgreement?.intro?.dateIn && moment(fixAgreement?.intro?.dateIn).format('DD/MM/yyyy hh:mm a')}
              </span>
            </div>
            <div className="flex flex-row nice-gap-1rem">
              <span className="text-30 text-nowrap text-capitalize">
                {trans('fixAgreemnet:the_date_time_of_the_promised_delivery')}:
              </span>
              <span className="text-30 language-en ">
                {fixAgreement?.intro?.receivingDate && moment(fixAgreement?.intro?.receivingDate).format('DD/MM/yyyy hh:mm a')}
              </span>
            </div>
            <div className="flex flex-row nice-gap-1rem">
              <span className="text-30 text-nowrap text-capitalize">
                {trans('fixAgreemnet:reception_engineer')}:
              </span>
              <span className="text-30 line-break" dir="ltr">
                {fixAgreement?.intro?.receiverFullName}
              </span>
            </div>
            <div className="flex flex-row nice-gap-1rem">
              <span className="text-30 text-nowrap text-capitalize">
                {trans('new:mobile')}:
              </span>
              <span className="text-24 text-bold text-info-light language-en" dir="ltr">
                {fixAgreement?.intro?.empMobile && <a
                  className="text-30 text-bold text-info-light language-en border-line-b"
                  href={'tel:' + fixAgreement?.intro?.empMobile}
                >
                  {fixAgreement?.intro?.empMobile}
                </a>
                }
              </span>
            </div>
          </div>
          {/* end agreement */}

          {/*start estimations*/}
          {
            (addationals && addationals?.length > 0) && <div className="nice-container flex flex-col nice-gap-1rem mt-10">
              <div className="flex flex-row nice-gap-1rem">
                <span className="text-34 text-bold text-nowrap text-capitalize text-underline">
                  {trans('fixAgreemnet:requests_during_fix')}
                </span>
              </div>
              <div className="flex flex-row nice-gap-1rem">
                <span className="flex-grow"></span>
                <span className="text-30 text-nowrap text-capitalize center-item">
                  {trans('fixAgreemnet:number')}
                </span>

                <span className="text-30 text-nowrap text-capitalize center-item">
                  {trans('fixAgreemnet:cost')}
                </span>

                <span className="text-30 text-nowrap text-capitalize center-item">
                  {trans('fixAgreemnet:agreement')}
                </span>
              </div>
              {addationals?.map((item, index) => {
                return (
                  <div key={index.toString()}>
                    <div className="flex flex-row nice-gap-1rem">
                      <span className="text-30 text-nowrap text-capitalize flex-grow">
                        {'- ' + item?.itemName}
                      </span>
                      <span className="text-30 text-nowrap text-capitalize center-item">
                        {item?.qty}
                      </span>

                      <span className="text-30 text-nowrap text-capitalize center-item">
                        <Price price={item?.priceAfterDisc} showZero={true} />
                      </span>

                      <span className="text-30 text-nowrap text-capitalize center-item">
                        <input type='checkbox' onChange={(event) => {
                          checkAddationalItem(event, item)
                        }}
                          checked={(item?.approval) ? (item?.approval) : false}
                          readOnly={fixAgreement?.intro?.isClosed ? true : false}
                        />
                      </span>
                    </div>
                  </div>
                )
              })}

              <div className="flex flex-row nice-gap-1rem text-bold">
                <span className="flex-grow"></span>
                <span className="border-bottom"></span>
              </div>
              {!fixAgreement?.intro?.isClosed &&
                <div className="flex flex-row nice-gap-1rem">
                  <span className="flex-grow"></span>
                  <label className="text-30">{trans('fixAgreemnet:select_all')}</label>
                  <span className="text-30 text-nowrap text-capitalize center-item">
                    <input
                      ref={checkAllRef}
                      type={'checkbox'}
                      onChange={() => {
                        checkAllAddational()
                      }}
                      checked={noneItems}
                    />

                  </span>
                </div>}
            </div>
          }

          {/*end estimations*/}
          {/* start notes */}

          {fixAgreement?.intro?.taskSummary?.length > 0 &&
            <div className="nice-container flex flex-col nice-gap-1rem mt-10">
              <div className="flex flex-row nice-gap-1rem">
                <span className="text-34 text-bold text-nowrap text-capitalize text-underline">
                  {trans('fixAgreemnet:notes')}
                </span>
              </div>
              {fixAgreement?.intro?.taskSummary?.map((item, index) => {
                return (
                  <div key={index.toString()}>
                    <div className="flex flex-row nice-gap-1rem">
                      <span className="text-30 text-nowrap text-capitalize flex-grow">
                        {'- ' + item}
                      </span>
                    </div>
                  </div>
                )
              })}
            </div>

          }

          {/* end notes */}

          <div className="carOverview-page-body nice-apply-theme">
            {/* start guest info */}
            <div className="panel-section panel-white nice-apply-theme">
              <div
                className={`panel-content   ${(indexPanel == '1000') & showPanel ? 'show-panel-info' : ''
                  }`}
              >
                <div
                  className="panel-content-top  nice-container"
                  onClick={(e) => showPanelInfo('1000')}
                >
                  <h1 className="text-40 text-super-gray  text-capitalize">
                    {' '}
                    {trans('fixAgreemnet:guest_information')}
                  </h1>

                  <img src="/assets/icons/arrow.svg" />
                </div>


                <div className="panel-content-body">
                  <div className="nice-container flex flex-col nice-gap-1rem ">
                    <Table striped bordered hover size="sm" className='border-spacing-1'>
                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:vehicle_owner')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.host?.vehOwner}

                          </td>
                        </tr>

                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('new:mobile')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement != null ? fixAgreement?.host?.ownerMobile : ''}

                          </td>
                        </tr>
                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:Identity_or_residence')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.host?.identityNo}
                          </td>
                        </tr>

                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:who_brought_the_vehicle')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.host?.vehGetter}
                          </td>
                        </tr>

                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('new:mobile')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.host?.vehGetterMobile}
                          </td>
                        </tr>


                      </tbody>
                    </Table>
                  </div>
                </div>




              </div>
            </div>

            {/* end guest info */}

            {/* start service info */}
            <div className="panel-section nice-apply-theme panel-white">
              <div
                className={`panel-content   ${(indexPanel == '2000') & showPanel ? 'show-panel-info' : ''
                  }`}
              >
                <div
                  className="panel-content-top nice-container"
                  onClick={(e) => showPanelInfo('2000')}
                >
                  <h1 className="text-40 text-super-gray  text-capitalize">
                    {' '}
                    {trans('fixAgreemnet:service_information')}
                  </h1>

                  <img src="/assets/icons/arrow.svg" />
                </div>

                <div className="panel-content-body">
                  <div className="nice-container flex flex-col nice-gap-1rem ">
                    <Table striped bordered hover size="sm" className='border-spacing-1'>
                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:payment_method')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.service?.paymentType}

                          </td>
                        </tr>

                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:service_type')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.service?.serviceName}

                          </td>
                        </tr>
                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:repair_type')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.service?.maintenanceName}
                          </td>
                        </tr>

                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:guest_type')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.service?.hostType}
                          </td>
                        </tr>

                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:hand_over_the_old_pieces')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.service?.oldPartsDelivery ? trans("fixAgreemnet:yes") : trans("fixAgreemnet:no")}
                          </td>
                        </tr>
                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:vehicle_transportation_service')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.service?.vehicleTransport ? trans("fixAgreemnet:yes") : trans("fixAgreemnet:no")}
                          </td>
                        </tr>
                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:notes_last_visit')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.service?.hasLastJobCard ? trans("fixAgreemnet:yes") : trans("fixAgreemnet:no")}
                          </td>
                        </tr>


                      </tbody>
                    </Table>
                  </div>
                </div>



              </div>
            </div>
            {/* end service info */}

            {/* start vehicle info */}
            <div className="panel-section nice-apply-theme panel-white">
              <div
                className={`panel-content   ${(indexPanel == '3000') & showPanel ? 'show-panel-info' : ''
                  }`}
              >
                <div
                  className="panel-content-top nice-container"
                  onClick={(e) => showPanelInfo('3000')}
                >
                  <h1 className="text-40 text-super-gray  text-capitalize">
                    {' '}
                    {trans('fixAgreemnet:vehicle_information')}
                  </h1>

                  <img src="/assets/icons/arrow.svg" />
                </div>

                <div className="panel-content-body">
                  <div className="nice-container flex flex-col nice-gap-1rem ">
                    <Table striped bordered hover size="sm" className='border-spacing-1'>
                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:brand_and_model')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.vehicle?.brandWithModel}

                          </td>
                        </tr>

                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:structure_number')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.vehicle?.vin}

                          </td>
                        </tr>
                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:plate_number_and_color')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.vehicle?.plateNOWithColor}
                          </td>
                        </tr>

                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:the_date_of_purchase')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.vehicle?.purchaseDate && moment(fixAgreement?.vehicle?.purchaseDate).format('DD/MM/yyyy')}
                          </td>
                        </tr>

                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:meter_reading')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.vehicle?.newKilometers}
                          </td>
                        </tr>
                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:fuel_indicator')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.vehicle?.fuelMeter}
                          </td>
                        </tr>
                        <tr className="">
                          <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('fixAgreemnet:warning_lights')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {fixAgreement?.vehicle?.warningLight ? trans("fixAgreemnet:yes") : trans("fixAgreemnet:no")}
                          </td>
                        </tr>


                      </tbody>
                    </Table>
                  </div>
                </div>






              </div>
            </div>
            {/* end vehicle info */}

            {/* start visual_inspection_of_the_vehicle */}
            <div className="panel-section nice-apply-theme panel-white">
              <div
                className={`panel-content   ${(indexPanel == '4000') & showPanel ? 'show-panel-info' : ''
                  }`}
              >
                <div
                  className="panel-content-top nice-container"
                  onClick={(e) => showPanelInfo('4000')}
                >
                  <h1 className="text-40 text-super-gray  text-capitalize">
                    {trans('fixAgreemnet:visual_inspection_of_the_vehicle')}
                  </h1>

                  <img src="/assets/icons/arrow.svg" />
                </div>

                <div className="panel-content-body">
                  <div className="nice-container flex flex-col nice-gap-1rem ">
                    <div className="flex flex-col nice-gap-1rem ">
                      <div className="flex flex-row nice-gap-3rem mt-10">
                        <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                          {trans('fixAgreemnet:dent')}
                        </span>
                        <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                          {trans('fixAgreemnet:scratches')}
                        </span>
                        <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                          {trans('fixAgreemnet:rust')}
                        </span>
                        <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                          {trans('fixAgreemnet:fractures')}
                        </span>
                        <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                          {trans('fixAgreemnet:peel')}
                        </span>
                      </div>

                      <div className="flex flex-row height-50  pr-40  pl-40">
                        {fixAgreement?.vehicle?.carImage ? <img src={'data:image/png;base64,' + fixAgreement?.vehicle?.carImage} alt="drow" className='draw-image' /> :
                          <img src="/assets/test/draw.png" alt="/assets/images/default.png" />
                        }
                      </div>

                      {
                        fixAgreement?.intro?.note &&


                        <div className="my-5 nice-apply-theme bg-theme-up">
                          <span className="text-30 mb-8 text-bold text-nowrap  text-capitalize text-underline">
                            {trans('fixAgreemnet:notes')}
                          </span>
                          <p className="text-30 mt-5 text-gray"> {fixAgreement?.intro?.note}</p>
                        </div>

                      }

                      <div className="flex flex-row nice-gap-1rem ">
                        <span className="text-30 text-bold text-nowrap height-5 text-capitalize text-underline">
                          {trans('fixAgreemnet:tools')}
                        </span>
                      </div>



                      <div className="flex flex-row nice-gap-3rem ">
                        <div className="flex flex-nowrap nice-gap-1rem">
                          <div className="flex flex-col nice-gap-1rem ">
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:floor_rug')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:extinguisher')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:lighter')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:spare_tire')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:car_lift')}
                            </span>
                          </div>
                          {
                            fixAgreement &&

                            <div className="flex flex-col nice-gap-1rem ">
                              <span className="text-24 text-bold text-nowrap  text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems && outerItems["FloorMat"] && outerItems["FloorMat"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems && outerItems["AshTry"] && outerItems["AshTry"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems && outerItems["Lighter"] && outerItems["Lighter"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems && outerItems["SpareTire"] && outerItems["SpareTire"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems && outerItems["WhealJack"] && outerItems["WhealJack"] == true) ? true : false} />
                              </span>
                            </div>

                          }

                        </div>

                        <div className="nice-gap-1rem"></div>
                        <div className="flex flex-row nice-gap-1rem">
                          <div className="flex flex-col nice-gap-1rem ">
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:wheel_covers')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:toolbox')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:metal_wheel')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:metal_wheel_lock')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:first_aid_kit')}
                            </span>
                          </div>
                          {
                            fixAgreement &&
                            <div className="flex flex-col nice-gap-1rem ">
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems["WheelCaps"] && outerItems["WheelCaps"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems["ToolBox"] && outerItems["ToolBox"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems["AllyWheel"] && outerItems["AllyWheel"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems["AllyWheelLock"] && outerItems["AllyWheelLock"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems["FirstAidKit"] && outerItems["FirstAidKit"] == true) ? true : false} />
                              </span>
                            </div>

                          }

                        </div>
                        <div className="nice-gap-1rem"></div>
                        <div className="flex flex-row nice-gap-1rem">
                          <div className="flex flex-col nice-gap-1rem ">
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:remote')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:USB_storage_device')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:dial_screen')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:navigation_memory_card')}
                            </span>
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              {trans('fixAgreemnet:air_compressor')}
                            </span>
                          </div>

                          {
                            outerItems &&
                            <div className="flex flex-col nice-gap-1rem ">
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems["SmartKeyRemote"] && outerItems["SmartKeyRemote"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems["USBDevice"] && outerItems["USBDevice"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems["DVDnavScreen"] && outerItems["DVDnavScreen"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems["NavMemoryCard"] && outerItems["NavMemoryCard"] == true) ? true : false} />
                              </span>
                              <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                                <input type={'checkbox'} readOnly={true} checked={(outerItems["AirComprissor"] && outerItems["AirComprissor"] == true) ? true : false} />
                              </span>
                            </div>

                          }

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* end visual_inspection_of_the_vehicle */}
            {/* start visual_inspection_of_the_vehicle */}
            <div className="panel-section nice-apply-theme panel-white">
              <div
                className={`panel-content   ${(indexPanel == '5000') & showPanel ? 'show-panel-info' : ''
                  }`}
              >
                <div
                  className="panel-content-top nice-container"
                  onClick={(e) => showPanelInfo('5000')}
                >
                  <h1 className="text-40 text-super-gray  text-capitalize">
                    {' '}
                    {trans('fixAgreemnet:vehicle_photos')}
                  </h1>

                  <img src="/assets/icons/arrow.svg" />
                </div>

                <div className="panel-content-body">
                  <div className="nice-container flex flex-col nice-gap-1rem p-10">
                    <div className="flex flex-col nice-gap-1rem ">
                      <div className="flex flex-row nice-gap-1rem ">
                        <Swiper
                          // spaceBetween={50}
                          spaceBetween={20}
                          slidesPerView={fixAgreement?.carImages?.length > 1 ? 1.5 : 1}
                          resizeObserver={true}
                          grabCursor={true}
                          onSlideChange={() => console.log('slide change')}
                          onSwiper={(swiper) => console.log(swiper)}
                        >
                          {vehicleAtts?.map((item, index) => {
                            return (
                              <SwiperSlide key={index.toString()}>
                                <div>
                                  <img
                                    className=" border-radius"
                                    alt={`veh-image-${index}`}
                                    src={
                                      'data:image/png;base64,' + item
                                    }
                                  />
                                </div>
                              </SwiperSlide>
                            )
                          })}
                        </Swiper>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* end visual_inspection_of_the_vehicle */}

            {/* start center info */}
            <div className="panel-section nice-apply-theme panel-white">
              <div
                  className={`panel-content  show-panel-info ${(indexPanel == '6000') & showPanel ? 'show-panel-info' : ''
                  }`}
              >
                <div
                  className="panel-content-top nice-container"
                  onClick={(e) => showPanelInfo('6000')}
                >
                  <h1 className="text-40   text-super-gray text-capitalize">
                    {' '}
                    {trans('new:center_information')}{' '}
                  </h1>

                  <img src="/assets/icons/arrow.svg" />
                </div>

                <div className="panel-content-body">

                  <CenterInfo data={cinderInfo}/>

                  {/*<div className="nice-container p-10 flex flex-row flex-wrap nice-gap-2rem">*/}
                  {/*  <div className="flex flex-row nice-gap-1rem">*/}
                  {/*    <span className="text-24 text-bold text-super-gray text-capitalize">*/}
                  {/*      {trans('new:service_provider')} :*/}
                  {/*    </span>*/}
                  {/*    <span className="text-24 text-bold text-super-gray text-capitalize">*/}
                  {/*      {trans('new:HJ_company')}*/}
                  {/*    </span>*/}
                  {/*  </div>*/}
                  {/*  <div className="border-l text-gray-dark my-3 mx-5"></div>*/}
                  {/*  <div className="flex flex-row nice-gap-1rem">*/}
                  {/*    <span className="text-24 text-bold text-super-gray text-capitalize">*/}
                  {/*      {trans('new:tax_number')} :*/}
                  {/*    </span>*/}
                  {/*    <span className="text-24 text-bold text-super-gray ">*/}
                  {/*      {'311073142900003'}*/}
                  {/*    </span>*/}
                  {/*  </div>*/}
                  {/*  /!* <div className="border-l text-gray-dark my-3 mx-5"></div> *!/*/}
                  {/*  <div className="flex flex-row nice-gap-1rem">*/}
                  {/*    <span className="text-24 text-bold text-super-gray text-capitalize">*/}
                  {/*      {trans('new:address')} :*/}
                  {/*    </span>*/}
                  {/*    <span className="text-24 text-bold text-super-gray  ">*/}
                  {/*      {trans('new:Dammam_KingFahd_suburb_car_showroom')}*/}
                  {/*    </span>*/}
                  {/*  </div>*/}
                  {/*  <div className="border-l text-gray-dark my-3 mx-5"></div>*/}
                  {/*  <div className="flex flex-row nice-gap-1rem">*/}
                  {/*    <span className="text-24 text-bold text-super-gray text-capitalize">*/}
                  {/*      {trans('new:commercial_record')} :*/}
                  {/*    </span>*/}
                  {/*    <span className="text-24 text-bold text-super-gray ">*/}
                  {/*      {'2050011700'}*/}
                  {/*    </span>*/}
                  {/*  </div>*/}
                  {/*  /!* <div className="border-l text-gray-dark my-3 mx-5"></div> *!/*/}
                  {/*  <div className="flex flex-row nice-gap-1rem">*/}
                  {/*    <span className="text-24 text-bold text-super-gray text-capitalize">*/}
                  {/*      {trans('new:postal_code')} :*/}
                  {/*    </span>*/}
                  {/*    <span className="text-24 text-bold text-super-gray ">*/}
                  {/*      {'31441'}*/}
                  {/*    </span>*/}
                  {/*  </div>*/}
                  {/*  <div className="border-l text-gray-dark my-3 mx-5"></div>*/}
                  {/*  <div className="flex flex-row nice-gap-1rem">*/}
                  {/*    <span className="text-24 text-bold text-super-gray text-capitalize">*/}
                  {/*      {trans('new:mail_box')} :*/}
                  {/*    </span>*/}
                  {/*    <span className="text-24 text-bold text-super-gray ">*/}
                  {/*      {'1666'}*/}
                  {/*    </span>*/}
                  {/*  </div>*/}
                  {/*  /!* <div className="border-l text-gray-dark my-3 mx-5"></div> *!/*/}
                  {/*  <div className="flex flex-row nice-gap-1rem">*/}
                  {/*    <span className="text-24 text-bold text-super-gray text-capitalize">*/}
                  {/*      {trans('new:contact_numbers')} :*/}
                  {/*    </span>*/}
                  {/*    <div className="flex flex-row nice-gap-2rem">*/}
                  {/*      <span className="text-24 text-bold text-info-light language-en border-line-b">*/}
                  {/*        <a*/}
                  {/*          className="text-24 text-bold text-info-light language-en "*/}
                  {/*          href={'tel:+966 13 820 5000'}*/}
                  {/*        >*/}
                  {/*          {'+966 13 820 5000 '}*/}
                  {/*        </a>*/}
                  {/*      </span>*/}
                  {/*      <span className="text-24 text-bold text-info-light language-en border-line-b">*/}
                  {/*        <a*/}
                  {/*          className="text-24 text-bold text-info-light language-en "*/}
                  {/*          href={'tel:+966 13 820 5000'}*/}
                  {/*        >*/}
                  {/*          {' +966 13 820 5000 '}*/}
                  {/*        </a>*/}
                  {/*      </span>*/}
                  {/*    </div>*/}
                  {/*  </div>*/}
                  {/*</div>*/}


                </div>
              </div>
            </div>
            {/* end center info */}
            <div className="flex flex-row nice-gap-1rem nice-container margin-vertical">
              <div
                className="text-30 mb-20"
                onClick={() => {
                  // callTerms();
                  // setShowTermsPopup(true);
                  console.warn("termsSalesOrders.length != 0", termsSalesOrders.length);
                  if (termsSalesOrders.length !== 0) {
                    setShowTermsPopup(true);
                  }
                }}
              >
                {trans('mobileCommon:approve_agreement')}&nbsp;
                <span className="text-info-light text-30 mx-1">
                  {trans('mobileCommon:cart_agreement_part2')}
                </span>
                {trans('mobileCommon:cart_agreement_part3')}
              </div>
            </div>
            <div className="flex flex-row nice-gap-1rem nice-container">
              <span className="text-30 text-bold text-super-gray text-capitalize flex-grow">
                {trans('fixAgreemnet:estimated_repair_costs')}
              </span>
              <span className="text-30 text-bold text-super-gray text-capitalize font-bold">
                <Price price={addationalPrice ? (((addationalPrice) * 100) / 115) : 0} showZero={true} />
              </span>
            </div>

            <div className="flex flex-row nice-gap-1rem nice-container">
              <span className="text-30 text-bold text-super-gray text-capitalize flex-grow">
                {trans('fixAgreemnet:discount')}
              </span>
              <span className="text-30 text-bold text-super-gray text-capitalize font-bold">
                <Price price={fixAgreement?.intro?.discountTotal} showZero={true}/>
              </span>
            </div>

            <div className="flex flex-row nice-gap-1rem nice-container">
              <span className="text-30 text-bold text-super-gray text-capitalize flex-grow">
                {trans('mobileCommon:tax')}
              </span>
              <span className="text-30 text-bold text-super-gray text-capitalize font-bold">
                <Price price={((((addationalPrice) * 100) / 115) * 0.15)} showZero={true}/>
              </span>
            </div>

            <div className="nice-container">
              <div className="border-line"></div>
            </div>
            <div className="flex flex-row nice-gap-1rem nice-container mb-10">
              <span className="text-30 font-bold text-capitalize flex-grow">
                {trans('fixAgreemnet:estimated_total')}
              </span>
              <span className="text-30 cart-bill-row-item mx-2 margin-top">
                {trans('fixAgreemnet:VAT_included')}
              </span>
              <span className="text-34 font-bold text-capitalize font-bold">
                <Price price={addationalPrice} showZero={true} />
              </span>
            </div>


            {(!fixAgreement?.intro?.isClosed
                && fixAgreement?.intro?.orderStatus == "Open wait Approval"
                && hasaddationals)
                ? <div className="flex-row nice-gap-1rem nice-container mb-20">

                  {fixAgreement?.intro
                      ? <SimpleButton
                          className={!isLoadingBtn ? "text-white bg-primary text-20 basis-2/4 my-10 order-1"
                              : "text-white bg-gray text-20 basis-2/4 my-10 order-1"}
                          isLoading={isLoadingBtn}
                          title={!isLoadingBtn ? trans("fixAgreemnet:agree_to_the_agreement") : ''}
                          onClick={async () => {
                            if (!isLoadingBtn) {
                              // setShowPopup(true)
                              // handelGoCheckSms();
                              await handelGoCheckSms();
                              console.log("BTN");
                            }
                          }}/>
                      : <></>
                  }

                </div>
                : !addationals?.length > 0 &&
                <div className="flex-row nice-gap-1rem nice-container mb-20">
                  {
                      fixAgreement?.intro?.orderNo &&
                      <div className="cart-finalized-code-Custom px-4"
                           onClick={() => {
                           }}
                      >
                        <span className="text-34 font-bold text-white mx-2">{
                          trans("new:Pre-approved")
                        }</span>

                        <code className="text-white text-30 language-en">
                          {postedDate && moment(postedDate).format('hh:mm a').toUpperCase()}
                        </code>

                        <code className="text-white text-30">
                          {postedDate && moment(postedDate).format('DD/MM/yyyy')}
                        </code>
                        {/*<img src="/assets/icons/copy.svg" alt='copy' />*/}
                      </div>
                  }
                </div>
            }
          </div>

          <Suspense>
            <PopupWithHeading
              className={"popup-container-auto"}
              show={showPopup}
              backButton={true}
              onStatusChange={(status) => {
                setShowPopup(false);
              }}
            >
              <SMSCheck
                mobile={fixAgreement?.host?.ownerMobile}
                onSucess={() => {
                  nextStepCallback();
                }}
              />
            </PopupWithHeading>
            <PopupWithHeading
                terms={true}
              backButton={false}
              show={showTermsPopup}
              title={trans("mobileCommon:cart_agreement_part2")}
              onStatusChange={(status) => {
                setShowTermsPopup(false);
              }}

            >

              <ul className="my-20 p-20 flex flex-col top-margin-t">
                {

                  termsSalesOrders.map((term, index) => {
                    return (

                        term &&
                        <li key={index} className={"text-30  my-5 "}>
                          {
                              !term.includes("<>") &&
                              <>
                                <span className="text-30 text-bold ">{term}</span>
                              </>
                          }

                          {
                              term.includes("<>") &&
                              term.split('<>').slice(1).map((termsub, indexsub) => {
                                return (
                                    termsub &&
                                    <h6 key={indexsub} className="text-30 text-bold ">{"-"} <span
                                        className="text-30 text-bold ">{termsub}</span></h6>

                                );
                              })
                          }
                        </li>
                    );
                  })
                }


              </ul>

              {/*<div className="my-20 p-5 flex flex-col">*/}
              {/*  {*/}
              {/*    termsSalesOrders && <img src={termsSalesOrders.image ? "data:image/png;base64," + termsSalesOrders.image : '/assets/images/default.png'} alt={termsSalesOrders.title ?? 'salesAgreement'} />*/}
              {/*  }*/}
              {/*</div>*/}
            </PopupWithHeading>


            <Popup show={showFinalPopup}>
              <div className="w-full h-full flex justify-center items-center" >
                <div className="cart-finalized" ref={popRef}>
                  {/* <div className="popup-close nice-select-none" onClick={() => {

                                setShowFinalPopup(false);

                            }}>
                                {"x"}
                            </div> */}
                  <div className="cart-finalized-container">
                    <img src="/assets/images/finalized.svg" />
                  </div>
                  <div className="flex flex-wrap justify-center">
                    <span className="text-34 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                    <span className="text-34 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                  </div>



                  {
                      ((!fixAgreement?.intro?.isClosed
                          && fixAgreement?.intro?.orderStatus == "Open wait Approval"
                          && !hasaddationals) && fixAgreement?.intro) &&
                    <div className="flex flex-row justify-center mb-10">
                      <span
                          className="text-34 font-bold text-gray mx-2">{trans("new:There_are_no_additions") + !fixAgreement?.intro?.isClosed}</span>
                    </div>
                  }

                  {
                    !fixAgreement?.intro &&
                    <div className="flex flex-row justify-center mb-10">
                      <span className="text-34 font-bold text-gray mx-2">{trans("new:agreement_link_is_incorrect")}</span>
                    </div>
                  }

                  {
                    fixAgreement?.intro?.orderNo &&
                    <div className="cart-finalized-code"

                      onClick={() => {

                        navigator.clipboard.writeText(fixAgreement?.intro?.orderNo ? fixAgreement?.intro?.orderNo : "");
                        toast.success(trans("messages:copied_successfully"));
                      }}
                    >
                      <span className="text-34 font-bold text-white mx-2">{trans('fixAgreemnet:agreement_number') + ":"}</span>
                      <code className="text-white text-30">{fixAgreement?.intro?.orderNo ? fixAgreement?.intro?.orderNo : ""}</code>
                      <img src="/assets/icons/copy.svg" alt='copy' />
                    </div>
                  }

                </div>
              </div>
            </Popup>
          </Suspense>
        </>
      </div >
    ))
}
export default Addationals
